<template>
  <div class="form-viewer  mxw-md" v-if="currentForm">
    <h1 class="form-name" v-if="currentForm.isActive"> {{ currentForm.name  }} </h1>
    <div class="inactive" v-else>
      <h1> This form is not currently accepting submissions </h1>
      <el-button type="primary" @click="$router.push('/')"> Go Home </el-button>
    </div>
    <p class="form-description f-light">
      {{ currentForm.description }}
    </p>
    <p class="timestamp" v-if="currentForm.submittedForms">
      Last Submitted Date: {{ getLastTimeStamp(currentForm) }} by {{ getLastMember(currentForm) }}
    </p>
    <template v-for="(group, index) in currentForm.groups">
      <div :key="index" >
        <div :class="{ 'group-container': true }">
          <h2 class='group-name'>
            {{ currentForm.groups[index].name }}
          </h2>
          <el-row class="form-field-container">
            <!-- FORM FIELDS -->
            <el-form :model="currentForm.groups[index]" :disabled="isExpired(currentForm.expiration)">
              <template v-for="(field, fIndex) in currentForm.groups[index].fields">
                <el-col
                  v-if="field.type === 1"
                  :span="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :md="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :sm="23"
                  :xs="23"
                  class="form-field"
                  :key="fIndex"
                >
                  <el-input-title :required="field.required" v-if="field.label && field.type !== 4">{{ field.label }}</el-input-title>
                  <!-- <span class="ml-02" v-else>{{ field.label }}</span> -->
                  <el-form-item :class="{ 'mt-10': field.type !== 'description' }">
                    <!-- INPUT -->
                    <el-input  v-model="currentForm.groups[index].fields[fIndex].value"/>
                  </el-form-item>
                </el-col>
                <el-col
                  v-else-if="field.type === 2"
                  :span="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :md="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :sm="23"
                  :xs="23"
                  class="form-field"
                  :key="fIndex"
                >
                  <el-input-title :required="field.required" v-if="field.label && field.type !== 4">{{ field.label }}</el-input-title>
                  <!-- <span class="ml-02" v-else>{{ field.label }}</span> -->
                  <el-form-item :class="{ 'mt-10': field.type !== 'description' }">
                    <!-- SELECT -->
                    <el-select  v-model="currentForm.groups[index].fields[fIndex].value">
                      <el-option v-for="{value} in field.options" :label="value" :value="value" :key="value"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col
                  v-else-if="field.type === 3"
                  :span="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :md="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :sm="23"
                  :xs="23"
                  class="form-field"
                  :key="fIndex"
                >
                  <el-input-title :required="field.required" v-if="field.label && field.type !== 4">{{ field.label }}</el-input-title>
                  <!-- <span class="ml-02" v-else>{{ field.label }}</span> -->
                  <el-form-item :class="{ 'mt-10': field.type !== 'description' }">

                    <!-- NUMBER -->
                    <el-input-number  v-model="currentForm.groups[index].fields[fIndex].value" />
                    <!-- <p v-else-if="field.type === 'description'" class="field-description"> {{ field.description }} </p> -->

                  </el-form-item>
                </el-col>
                <el-col
                  v-else-if="field.type === 4"
                  :span="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :md="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :sm="23"
                  :xs="23"
                  class="form-field"
                  :key="fIndex"
                >
                  <!-- <el-input-title :required="field.required" v-if="field.label && field.type !== 4">{{ field.label }}</el-input-title> -->
                  <span class="ml-02" >{{ field.label }}</span>
                  <el-form-item :class="{ 'mt-10': field.type !== 'description' }">
                    <!-- TABLE -->
                    <el-table
                      class="item-table"
                      :data="field.tableData"
                      border
                      style="width: 100%">
                      <el-table-column
                        v-for="(data, index) in field.tableHeaders"
                        :key="`table-column-${index}`"
                        :prop="data.value"
                        :label="data.value">
                        <template v-slot="scope">
                          <el-input v-model="scope.row[data.value]" />
                                  <!-- <span v-else>
                                    {{ scope.row[data.value] }}
                                  </span> -->
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                </el-col>
                <el-col
                  v-else-if="field.type === 5"
                  :span="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :md="(field.type !== 'description') ? field.isExpanded? 23:11 : 23"
                  :sm="23"
                  :xs="23"
                  class="form-field"
                  :key="fIndex"
                >
                  <!-- <el-input-title :required="field.required" v-if="field.label && field.type !== 4">{{ field.label }}</el-input-title> -->
                  <span class="ml-02" >{{ field.label }}</span>
                  <el-form-item :class="{ 'mt-10': field.type !== 'description' }">
                    <!-- Upload -->
                    <el-upload
                      v-if="field.type === 5"
                      action="#"
                      :headers="uploadHeaders"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      :limit="1"
                      :on-exceed="handleExceed"
                      :on-change="(file) => handleChange(file, group._id, field._id)"
                      :auto-upload="false"
                      :file-list="field.fileUploads">
                      <el-progress v-show="isUploading[field._id]" :percentage="uploadPercentage" />
                      <el-button size="small" type="secondary">Click to upload</el-button>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </template>
            </el-form>
          </el-row>
        </div>
        <el-dialog title="Choose a member you are submitting the form for" :visible.sync="selectMemberModalVisible" :close-on-click-modal="false" >
          <div class="d-flex flex-column flex-center w-100" v-if="selectMemberModalVisible">
            <member-board @select-member="selectMemberAndSubmit" isFormSubmit :disablePrimaryCheckbox="true"  />
          </div>
        </el-dialog>
      </div>
    </template>
    <!-- <el-row align="center"> -->
      <div class="mt-10 d-flex gap-05 form-controls" v-if="currentForm.isActive">
        <el-button type="secondary" @click="$router.push({ path: '/' })">Cancel</el-button>
        <el-button type="danger" @click="initiateSubmit">Submit</el-button>
      </div>
    <!-- </el-row> -->
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import moment from 'moment';
import MemberBoard from '../../components/members/MemberBoard.vue';

export default {
  name: 'FormViewer',
  components: { MemberBoard },
  data() {
    return {
      selectMemberModalVisible: false,
      currentForm: undefined,
      selectedMember: undefined,
      isUploading: [],
      uploadPercentage: 0,
    };
  },
  async mounted() {
    if (this.$route.query && this.$route.query.formId) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      try {
        const res = await this.$http.get(`/assemble/api/v1/portal/forms/${this.$route.query.formId}`);
        const [form] = res.data.data;
        this.currentForm = form;
        this.$store.commit('loading', false);
      } catch (e) {
        this.$message.error(e.response.data.message);
        this.$store.commit('loading', false);
      }
    }
  },
  computed: {
    fileUpdateUrl() {
      return `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/files/presigned-url`;
    },
    ...mapGetters('user', [
      'uploadHeaders',
    ]),
  },
  methods: {
    getLastTimeStamp(form) {
      const data = form.submittedForms ? form.submittedForms : '';
      const lastDate = data.createdAt ? moment(data.modifiedAt || data.createdAt).format('MM/DD/YYYY') : '';
      return lastDate;
    },
    getLastMember(form) {
      return form.member ? `${form.member.profile.firstName} ${form.member.profile.lastName}` : '';
    },
    isExpired(expiry) {
      if (expiry) {
        if (+this.moment() <= expiry) return false;
        return true;
      }
      return false;
    },
    initiateSubmit() {
      const invalid = this.currentForm.groups.some((group) => group.fields.some((field) => field.required && !field.value));
      if (invalid) return this.$message.error('One or more required fields are missing');
      this.selectMemberModalVisible = true;
      return true;
    },
    selectMemberAndSubmit(memberId) {
      this.selectedMember = memberId;
      this.submit();
    },
    submit() {
      const formId = +this.$route.query.formId;
      const groups = this.currentForm ? this.currentForm.groups : undefined;
      console.log('groups', groups);
      if (!groups) return this.$message.error('Invalid form');
      const formattedGroups = groups.map(({ _id, name, fields }) => ({
        _id,
        name,
        fields: fields
          .filter((f) => f.type !== 'description')
          .map((f) => {
            if (f.type !== 4) {
              const {
                _id: fieldId, type, label, value, options, fileUploads
              } = f;
              return {
                _id: fieldId, type, label, value, options, fileUploads
              };
            }
            const {
              _id: fieldId, type, label, tableHeaders, tableData, tableRows
            } = f;
            return {
              _id: fieldId, type, label, tableHeaders, tableData, tableRows
            };
          })
      }));
      console.log('formattedGroups', formattedGroups);
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.post(`/assemble/api/v1/portal/forms/${formId}`, {
        groups: formattedGroups,
        submittedBy: this.selectedMember
      })
        .then(() => {
          this.$store.commit('loading', false);
          this.$message.success('Form submitted successfully');
          this.$router.push({ path: '/' });
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
      return true;
    },
    // file upload
    handleRemove(file, fileList, groupId, fieldId) {
      let groupIndex;
      let fieldIndex;

      if (this.currentForm && this.currentForm.groups) groupIndex = _.filter(this.currentForm.groups, (grp) => grp._id === groupId);
      if (groupIndex) fieldIndex = _.filter(this.currentForm.groups[groupIndex].fields, (flds) => flds._id === fieldId);

      this.currentForm.groups[groupIndex].fields[fieldIndex].fileUploads = [];
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The limit is 1, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
    },
    beforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      return true;
    },
    async handleChange(file, groupId, fieldId) {
      if (!this.beforeUpload(file.raw)) return false;

      this.$set(this.isUploading, fieldId, true);
      const res = await this.$http.post(
        this.fileUpdateUrl,
        {
          fileName: file.name
        },
        {
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          }
        }
      );
      const { url, name, s3Path } = res.data.data;

      await fetch(url, {
        method: 'PUT',
        body: file.raw,
        headers: { 'Content-Type': '*/*' },
      });

      let groupIndex;

      if (this.currentForm && this.currentForm.groups) groupIndex = _.findIndex(this.currentForm.groups, (grp) => grp._id === groupId);
      const fieldIndex = _.findIndex(this.currentForm.groups[groupIndex].fields, (flds) => flds._id === fieldId);

      this.currentForm.groups[groupIndex].fields[fieldIndex].fileUploads.push({
        name,
        url: s3Path
      });

      this.uploadPercentage = 0;
      this.$set(this.isUploading, fieldId, false);

      return true;
    },
    async beforeRemove(file) {
      console.log(file);
      const confirm = await this.$confirm('Are you sure you want to delete?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
      if (confirm) return true;
      return false;
    },
    //
  }
};
</script>

<style lang="scss" scoped>
  .el-input-number, .el-select {
    width: 100%;
  }

  .form-viewer {
    width: 100%;
    max-width: 1440px;
    min-height: 100vh;
    margin: 0 auto;
    background: #FFFFFF;
    border: 0.5px solid rgba(69, 69, 69, 0.15);
    box-shadow: 0px 3px 6px rgba(233, 233, 233, 0.5);
    border-radius: 3px;
    overflow-y: auto;
    padding: 1.8rem 3rem;

    .inactive { width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column; }

    .form-controls {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 1rem;
    }

    .form-name {
      font-size: 27px;
      line-height: 40px;
      margin-bottom: 1.5rem;
    }
    .form-description {
      margin-bottom: 2.5rem;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      max-width: 75%;
    }

    .group-container {
      &:hover {
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
      }
      border: 1px solid rgba(45, 58, 69, 0.15);
      border-radius: 6px;
      min-height: 28rem;
      transition: all 0.3s ease-in;
      margin-bottom: 2rem;

      .group-name {
        font-style: normal;
        font-weight: normal;
        font-size: 1.5rem;
        line-height: 24px;
        padding-left: 2rem;
        padding-right: 1rem;
        padding-top: 2rem;
      }

      .form-field-container {
        padding: 1rem;
        .form-field {
          margin: 0.5rem .75rem;
          padding: .5rem;
          border-radius: 6px;
          cursor: pointer;

          .field-description {
            line-height: 24px;
            font-size: 1.2rem;
            color: #606266;
          }
        }
      }
    }
  }
  ::v-deep .item-table {
    border: 1px solid rgba(45, 58, 69, 0.1);
    th {
      text-align: left;
    }
      background-color: white !important;
      padding-top: 2em;
      text-align: left;
  }
</style>
